import {Component, inject, Input} from '@angular/core';
import {SeriennummerSelect} from "../../../../../Akte/Controlls/SearchAndSelect/SeriennummerSelect";
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {Geraet} from '../../../../../Api/DcoApi/AktenEintraege/Geraet';
import {RestClient} from '../../../../../Api/DcoApi/Client/RestClient';

@Component({
  selector: 'app-select-serial',
    imports: [
        SeriennummerSelect
    ],
  templateUrl: './select-serial.html',
  styleUrl: './select-serial.css',
})
export class SelectSerial {
  modal = inject(NgbActiveModal);
  Device: Geraet | null = null;
  Client: RestClient = new RestClient();
  @Input() Auftrag: number = 0;
  @Input() Tausch: number = 0;
  async Rotate(){
    if(this.Device != null && this.Device.seriennummer != '') {
      await this.Client.Post<any, any>(`/Backend/Api/V2/Austausch/${this.Auftrag}/${(this.Tausch ? 'Re' : '')}SetSerialnumber?ReplaceDeviceSerial=${this.Device?.seriennummer}`, null)
      this.modal.close();
    }
  }
}
